import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Pasé años pensando que mi cuerpo estaba roto. Entrenaba 6 días a la semana y siempre estaba hinchada. Con el Método ERBF bajé la intensidad cuando debía y, por primera vez en mi vida, mi abdomen se ve plano incluso antes de mi periodo. Es libertad pura.',
  name: 'Valeria M.',
  age: '32 años',
  profession: 'Emprendedora'
}, {
  quote: 'Lo que más me sorprendió fue la energía. Antes vivía agotada después del gym. Ahora sé cuándo darlo todo y cuándo caminar. He perdido 4kg de inflamación que no se movían con nada. Mi ropa me queda mejor que a los 20.',
  name: 'Carla R.',
  age: '38 años',
  profession: 'Abogada'
}, {
  quote: 'Como madre de dos, no tengo tiempo que perder. Dejé de hacer clases de HIIT que me dejaban muerta y empecé a sincronizar mis pesas con mi ciclo. Mi celulitis disminuyó drásticamente porque mi cortisol finalmente bajó. Es el secreto mejor guardado del fitness femenino.',
  name: 'Elena G.',
  age: '41 años',
  profession: 'Diseñadora'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-emerald-900 relative border-y border-emerald-800/50" data-id="element-170">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-171">
        <FadeIn data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center" data-id="element-173">
            MUJERES REALES.{' '}
            <span className="text-gradient-gold" data-id="element-174">RESULTADOS REALES.</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 place-items-center" data-id="element-175">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-176">
              <div className="bg-emerald-950 p-8 rounded-2xl border border-gold-500/20 relative h-full flex flex-col" data-id="element-177">
                <QuoteIcon className="w-10 h-10 text-gold-500/30 absolute top-6 right-6" data-id="element-178" />
                <p className="text-emerald-50/90 font-body italic mb-8 relative z-10 flex-grow" data-id="element-179">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-emerald-800/50 pt-4 mt-auto" data-id="element-180">
                  <p className="font-heading font-bold text-lg text-gold-400" data-id="element-181">
                    {testimonial.name}
                  </p>
                  <p className="text-emerald-200/60 font-body text-sm" data-id="element-182">
                    {testimonial.age} • {testimonial.profession}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}